<!--常见问题-->
<template>
  <div class="com-table border problem clear">
    <el-menu
      default-active="2"
      class="el-menu-demo fl"
      :unique-opened="true"
      @open="handleOpen"
      @close="handleClose">
      <div class="problem-title">| &nbsp;&nbsp;&nbsp;产品介绍</div>
      <el-submenu index="1">
        <template slot="title">
          <span>招商智投</span>
        </template>
        <el-menu-item index="1-1" @click="tab = 0">产品概述</el-menu-item>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <span>渠道快服</span>
        </template>
        <el-menu-item index="2-1" @click="tab = 1">产品概述</el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <span>电话安全卫士</span>
        </template>
        <el-menu-item index="3-1" @click="tab = 2">产品概述</el-menu-item>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">
          <span>智见crm</span>
        </template>
        <el-menu-item index="4-1" @click="tab = 3">产品概述</el-menu-item>
      </el-submenu>
      <el-menu-item index="5" @click="tab = 4">
        <span slot="title">功能介绍</span>
      </el-menu-item>
      <div class="problem-title">| &nbsp;&nbsp;&nbsp;开通账户</div>
      <el-menu-item index="6" @click="tab = 5">
        <span slot="title">开户指引</span>
      </el-menu-item>
      <div class="problem-title">| &nbsp;&nbsp;&nbsp;充值和财务管理</div>
      <el-menu-item index="7" @click="tab = 6">
        <span slot="title">充值</span>
      </el-menu-item>
      <el-menu-item index="8" @click="tab = 7">
        <span slot="title">退款</span>
      </el-menu-item>
      <div class="problem-title">| &nbsp;&nbsp;&nbsp;报表和数据监测</div>
      <el-menu-item index="9" @click="tab = 8">
        <span slot="title">投放效果数据</span>
      </el-menu-item>
      <div class="problem-title">| &nbsp;&nbsp;&nbsp;积分规则</div>
      <el-menu-item index="10" @click="tab = 9">
        <span slot="title">规则说明</span>
      </el-menu-item>
    </el-menu>
    <div class="sketch fl">
      <div v-show="tab === 0">
        <div class="sketch-title">招商智投 - 产品介绍</div>
        <div class="sketch-conten">
          <p>招商智投包括智能问卷、智能策略、智能素材、媒体分析、投放数据分析、工作管理</p>
          <div class="sub-title">渠道问卷</div>
          <p>解决项目投放方案制定效率慢，复杂的分析工作。实现快速采集、分析客户项目数据，只需要几分钟反馈最优投放方案给客户。</p>
          <div class="sub-title">智能策略、智能素材、媒体分析、投放数据分析、工作管理</div>
          <p>解决复杂的代运营前期工作。通过沉淀广告数据，机器学习和人工审查实现投放策略和投放素材的标准化。实现渠道加盟商画像的积累、消费数据的分析，甄选出优质的渠道。实现广告策略分析、广告素材分析、加盟商分析、诊断库、财务数据分析，从而实现数据的效果和精准度。实现标准的项目管理、客户管理、人员业绩管理、风控管理、资源管理等提高效率和服务质量。项目确定投放，<span class="red">上线</span>就可保证效果和精准度。</p>
        </div>
      </div>
      <div v-show="tab === 1">
        <div class="sketch-title">渠道快服 - 产品介绍</div>
        <div class="sketch-conten">
         <p>话术问题挖掘、知识库管理，达到潜在加盟商即问即答，提高响应时效、专业度、工作强度，最终提高资源的要<span class="red">话率15%</span>，同时也降低企业人工客服支出的成本，实现<span class="red">人工0成本</span>。</p>
        </div>
      </div>
      <div v-show="tab === 2">
        <div class="sketch-title">电话安全卫士 - 产品介绍</div>
        <div class="sketch-conten">
          <p>通过号码活跃度、激活状态、流量使用、运营商服务、投诉情况等分析出号码的属性情况是否为：空号、实号、停机、沉默号、风险号，提供给话务人员作为电话呼叫的参考数据，<span class="red">节约话务人员的时间，快速筛选出意向客户，增强话务人员工作的信心和成就感</span>。</p>
        </div>
      </div>
      <div v-show="tab === 3">
        <div class="sketch-title">智见crm - 操作手册</div>
        <div class="sketch-conten">
          <p>通过对接市场主流crm系统，创建crm客户信息，提供话务排班、分组等匹配功能，达到资源按公司需求情况<span class="red">实时自动分配</span>到crm系统话务人员手里，提高资源的实效性。</p>
          <p>通过数据的深度挖掘形成广告投放的闭环，将资源的效果做广告的深度投放优化，提高广告投放的效果和精准度。</p>
          <div class="sketch-title">操作手册</div>
          <div>
            <div class="sub-title">1.广告智能投放，获得的资源，集中显示在资源列表页面</div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/re1.png"></span></div>
          </div>
          <div>
            <div class="sub-title">2.点击资源同步crm-推送配置-ec，先配置账号，保存账号，获取话务人员数据</div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/re2.png"></span></div>
          </div>
          <div>
            <div class="sub-title">3.点击资源同步crm-话务排班-日期配置，根据项目情况，导入话务人员</div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/re4.png"></span></div>
          </div>
          <div>
            <div class="sub-title">4.根据公司的话务人员情况，设置相关数据，保存提交</div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/re5.png"></span></div>
          </div>
          <div>
            <div class="sub-title">5.确认检查，是否所有日期都有配置</div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/re6.png"></span></div>
          </div>
          <div>
            <div class="sub-title">6.打开资源同步开关，保存</div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/re7.png"></span></div>
          </div>
          <div>
            <div class="sub-title">7.确认检查，是否正常推送</div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/re8.png"></span></div>
          </div>
          <div>
            <div class="sub-title">8.话务跟进资源情况之后，在ec上面修改客户类型。具体根据公司情况分类</br>
              <font style="font-size:14px">（参考标签：未接客户、一般客户、意向客户、重点客户、来访客户、成交客户、无效客户）</font>
            </div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/re9.png"></span></div>
          </div>
        </div>
      </div>
      <div v-show="tab === 4">
        <div class="sketch-title">功能介绍</div>
        <div class="sketch-conten">
          <div class="sub-title">1.资源产生前-渠道问卷填写</div>
          <div class="sub-title1">
            <p>填写项目数据情况，系统几分钟反馈投放的方案情况</p>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/gn1.png"></span></div>
          </div>
          <div class="sub-title">2.资源产生前-投放方案执行</div>
          <div class="sub-title1">
            <p>招商智投进行品牌项目数据收集，制定项目的广告投放策略、广告投放素材、甄选最佳媒体，同时通过系统智能分析过往相似项目的投放数据，保证各大广告平台产生足够效果和精准度的资源。</p>     <div class="sub-img"><span class="img"><img src="/static/images/crm/gn2.png"></span></div>
          </div>
          <div class="sub-title">3.资源产生中-资源获得</div>
          <div class="sub-title1">
            <p>广告投放中通过<span class="red">推广页的表单和智能聊天</span>，获取潜在加盟商数据</p>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/gn3.png"></span></div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/gn4.png"></span></div>
          </div>
          <div class="sub-title">4.资源产生后-资源展示</div>
          <div class="sub-title1">
            <p>通过电话安全卫士分析号码的情况，对号码质量生成一个评估参考。所有资源数据在渠道无忧官网系统中<span class="red">集中显示</span>。</p>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/gn5.png"></span></div>
          </div>
          <div class="sub-title">5.资源产生后-资源同步crm</div>
          <div class="sub-title1">
            <p>通过配置crm账号和话务排班，将资源通过指定规则<span class="red">实时自动分配</span>给公司的话务人员crm账号里面。</p>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/gn6.png"></span></div>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/gn7.png"></span></div>
          </div>
          <div class="sub-title">6.资源产生后-话务更新crm标签</div>
          <div class="sub-title1">
            <p>话务跟进完资源情况之后，<span class="red">及时更新</span>crm客户的标签，提高后续广告投放的效果和精准度。</p>
            <font style="font-size:14px">（参考标签：未接客户、一般客户、意向客户、重点客户、来访客户、成交客户、无效客户）</font><br>
            <div class="sub-img"><span class="img"><img src="/static/images/crm/gn8.png"></span></div>
          </div>
        </div>
      </div>
      <div v-show="tab === 5">
        <div class="sketch-title">如何开户？</div>
        <div class="sketch-conten">
          由于现在系统没有对用户开通自主注册功能，需要开户请联系在线客服。
        </div>
      </div>
      <div v-show="tab === 6">
        <div class="sketch-title">如何充值？</div>
        <div class="sketch-conten">
          暂不支持在线充值，充值请联系在线客服。
        </div>
      </div>
      <div v-show="tab === 7">
        <div class="sketch-title">如何退款？</div>
        <div class="sketch-conten">
          暂不支持在线退款，退款请联系在线客服。
        </div>
      </div>
      <div v-show="tab === 8">
        <div class="sketch-title">可以看见什么投放效果数据？</div>
        <div class="sketch-conten">
          我们根据大数据分析，对客户基本会关心的数据做了标准化显示，在登录-工作台即可查看到。
        </div>
        <div class="sketch-title" style="margin-top: 30px">如果想查看其他数据怎么办？</div>
        <div class="sketch-conten">
          如果想查看标准化显示的数据之外，请联系在线客服，提交你的需求，我们根据情况处理。
        </div>
      </div>
      <div v-show="tab === 9">
        <div class="sketch-title">渠道积分规则</div>
        <div class="sketch-conten">
          <div class="sub-title">渠道积分是什么？</div>
          <div class="sub-main">渠道积分是渠道无忧平台的通用积分，目前可以在渠道无忧积分商城使用。</div>
        </div>
        <div class="sketch-conten">
          <div class="sub-title">渠道积分有什么用？</div>
         <div class="sub-main"> 渠道积分可以兑换渠道无忧平台的指定礼品和服务。</div>
        </div>
        <div class="sketch-conten">
          <div class="sub-title">渠道积分怎么获取？</div>
          <div class="sub-main">渠道积分的获取方式很多，用户可以通过多种场景获得积分，如充值赠送、充值奖励、<br />
          签到奖励、官方奖励、活动奖励、充值消费、消费奖励、阅读奖励、分享奖励、其他、购物支付等。</div>
        </div>
        <div class="sketch-conten">
          <div class="sub-title">如何使用渠道积分？</div>
          <div class="sub-main"> 渠道无忧积分商城仅支持积分的支付方式，在下单时系统以积分进行结算。</div>
        </div>
        <div class="sketch-conten">
          <div class="sub-title">渠道积分的有效期多久？</div>
          <div class="sub-main">由于渠道积分是赠送的，积分的有效期根据渠道无忧平台运营情况而定，官方具有解释权。</div>
        </div>
        <div class="sketch-conten">
          <div class="sub-title">渠道积分在兑换服务时的兑换比例是多少？</div>
          <div class="sub-main">渠道积分和人民币的比例是2:1，即2个渠道积分等于人民币1元。</div>
        </div>
        <div class="sketch-conten">
          <div class="sub-title">为什么我账户中的渠道积分少了？渠道积分在哪些情况会被扣减？</div>
          <div class="sub-main">账户中的渠道积分少了可能存在以下情况：<br />
          1、商品下单（不支持退货，所以不支持积分退回）。<br />
          2、账户充值金额变化了。<br />
          3、账户违规获取渠道积分，平台处罚。<br />
          4、其他场景。<br />
          渠道积分和人民币的比例是2:1，即2个渠道积分等于人民币1元。</div>
        </div>
        <div class="sketch-conten">
          <div class="sub-title">为什么我完成了任务但是没有渠道积分？</div>
          <div class="sub-main">如出现这种情况，请先确认是否有完成任务，再联系客服处理。</div>
        </div>
        <div class="sketch-conten">
          <div class="sub-title">渠道积分是否可以提现？</div>
          <div class="sub-main">渠道积分是渠道无忧平台赠送的虚拟积分，不能提现和兑换人民币。</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        tab: 0
      }
    },
    methods: {
      handleOpen (key, keyPath) {
        // console.log(key, keyPath)
      },
      handleClose (key, keyPath) {
        // console.log(key, keyPath)
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';
  .problem {
    &-title{
      height:44px;
      line-height:44px;
      color:#085ecc;
    }
    .sketch {
      width:639px;
      min-height: 940px;
      margin-left: 50px;
      box-sizing: border-box;
      > div {
        .sketch-title {
          font-size: 16px;
          font-weight: bold;
          margin: 12px 0 20px;
          color:$color-black;
        }
        p {
          text-indent: 2em;
        }
        .sketch-conten {
          line-height: 30px;
          color:$color-gray;
          img{
            width: 100%;
          }
          .sub-img{
            border-bottom: 1px solid #EBEEF5;
            padding-bottom: 10px;
            margin-bottom: 30px;
            .img{
              width:80%;
              display: inline-block;
              position: relative;
              &:after {
                content: '';
                width:100%;
                height:100%;
                position: absolute;
                top:0;
                left:0;
                background: #3B73A8;
                opacity:0.03;
              }
            }
          }
        }
        .sub-title{
          color:#666;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .sub-title1{
          p{
            margin:5px 0;
          }
        }
        .sub-main{
          margin-bottom: 15px;
        }
        .red{
          color:#f00;
        }
      }
    }
  }
</style>
<style lang="scss">
  .problem{
    .el-menu-demo{
      width:222px;
      border:none;
    }
    .el-menu-item, .el-submenu__title{
      height:44px;
      line-height:44px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/CommonProblem.vue